import * as React from 'react';
import PropTypes from 'prop-types';

import useFeatureFlag from '../../hooks/useFeatureFlag';
import useModalManager from './ModalManager';
import useModalCounter from './ModalCounter';

BaseModalTracker.propTypes = {
    show: PropTypes.bool,
    onClose: PropTypes.func,
    disableClose: PropTypes.bool,
    disableEscape: PropTypes.bool,
    disableBlur: PropTypes.bool,
};

export default function BaseModalTracker({
    show,
    onClose,
    disableClose,
    disableEscape,
    disableBlur,
}) {
    // Modal counting
    const setCount = useModalCounter();
    React.useEffect(() => {
        if (show && setCount) {
            setCount(c => ++c);
            return () => setCount(c => Math.max(--c, 0));
        }
        return undefined;
    }, [setCount, show]);

    // History tracking
    const addModal = useModalManager(onClose);
    const enableHistoryTracking = useFeatureFlag('enableModalHistoryTracking');

    // Don't manage the modal state in the history if closing the modal is disabled
    const canManageHistory = enableHistoryTracking && !(disableBlur && disableClose && disableEscape);
    const manageOpenModal = canManageHistory && show && addModal;
    const onCloseRef = React.useRef();
    onCloseRef.current = onClose;
    React.useEffect(() => {
        let cleanup;
        if (manageOpenModal) {
            cleanup = manageOpenModal(onCloseRef);
        }

        return () => {
            if (cleanup) {
                cleanup();
            }
        };
    }, [manageOpenModal]);

    return null;
}

